import { Middleware } from '@reduxjs/toolkit';
import { History } from 'history';

import { locationChanged } from 'store/routing/slice';

/**
 * Creates a Redux middleware that listens to history changes
 * and dispatches them to the store.
 *
 * @param history - The history object to listen to
 * @returns A Redux middleware
 */
export const createHistoryMiddleware =
  (history: History): Middleware =>
  (store) => {
    // Set up the listener for future location changes
    history.listen((payload) => {
      store.dispatch(locationChanged(payload));
    });

    // Return the middleware function
    return (next) => (action) => next(action);
  };

export default createHistoryMiddleware;
